import { createAction, props } from "@ngrx/store";
import { IBreeceSelectorDetails } from "../../models/breece-selector-details.interface";

export namespace BreeceSelectorAction {
  export const initialize = createAction(
    '[breeceSelectorAction] initialize'
  )

  export const getBreeceSelectors = createAction(
    '[breeceSelectorAction] getBreeceSelectors',
    props<{
      enumName: string,
      enumLocation: string
    }>()
  );
  export const getBreceSelectorsSuccess = createAction(
    '[breeceSelectorAction] getBreeceSelectors success',
    props<{
      enumDetails: IBreeceSelectorDetails[]
    }>()
  );
  export const getBreceSelectorsFailed = createAction(
    '[breeceSelectorAction] getBreeceSelectors failed',
    props<{
      error: any; // TODO: Not handled yet
    }>()
  );
}


